import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { createProvider, Step } from '../../../../shared/IFE/step/step/step';
import { NotificationType } from '../../../../shared/IFE/components/notification/notification.component';
import { fadeInOut } from 'src/app/shared/utils/animations/fade-animation';
import { HouseType } from '../../../../shared/modules/evc-api/models/constants';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';

@Component({
  selector: 'app-house-type',
  providers: [createProvider(HouseTypeComponent)],
  templateUrl: './house-type.component.html',
  styleUrls: ['./house-type.component.scss'],
  animations: [fadeInOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HouseTypeComponent extends Step implements OnInit {
  readonly houseType = HouseType;
  readonly fields = Fields;
  readonly notificationType = NotificationType;

  readonly formName = 'evcSimulator';
  readonly stepName = 'house-type';

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  protected buildForm() {
    const group = {};
    group[Fields.houseType] = new UntypedFormControl('', [Validators.required]);
    group[Fields.parkingSpot] = new UntypedFormControl('', []);
    this.control = new UntypedFormGroup(group);
    this.subscribeToValueChanges(true);
  }

  protected valueChanges(values) {
    for (const [key, value] of Object.entries(values)) {
      this.control.get(key).patchValue(value, { emitEvent: false });
      this.updateFormValidity(key, value);
    }
    super.valueChanges(values);
  }

  private updateFormValidity(key: string, value: any): void {
    if (key === Fields.houseType) {
      const validator = value === HouseType.sharedResidence ? [Validators.requiredTrue] : [];
      const parkingSpotControl = this.control.get(Fields.parkingSpot);
      parkingSpotControl.setValidators(validator);
      parkingSpotControl.updateValueAndValidity({ emitEvent: false });
    }
  }
}

enum Fields {
  houseType = 'houseType',
  parkingSpot = 'parkingSpot',
}
